<template>
  <el-tag type="info" :hit="true" size="small"> {{ from }} - {{ to }} </el-tag>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'PeriodLabel',
  props: {
    from: {
      type: String,
      required: true
    },
    to: {
      type: String,
      required: true
    }
  }
})
</script>
<style lang="scss" scoped>
.el-tag {
  border: none !important;
  text-align: center;
}
</style>
